import PropTypes from 'prop-types';
import postsStrings from 'modules/posts/strings';

import { Wrapper, SearchBarWrapper, SearchBar, SearchBarIcon } from './RssFeedFilter.style';

const RssFeedFilter = ({ searchQuery, handleSearchBarInputChange }) => (
  <Wrapper>
    <SearchBarWrapper>
      <SearchBarIcon />
      <SearchBar
        placeholder={postsStrings.rssFeedFilter.searchBarPlaceholder}
        value={searchQuery}
        onChange={handleSearchBarInputChange}
      />
    </SearchBarWrapper>
  </Wrapper>
);
RssFeedFilter.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
};

export default RssFeedFilter;
